import { useRouter } from 'next/router';

import { useGetPaginateCarouselProduct } from '@api/promotion/promotion.rq';
import PlpVerticalCard from '@com/shared/cards/plpCard/vertical';
import NonOtcPlpVeticalCardShimmer from '@com/shared/cards/plpCard/verticalPlpCards/nonOtcPlpVeticalCardShimmer';
import useProductNavigation from '@hooks/useNavigateToPdp';
import Pagination from '@com/shared/ocs/Pagination';

const DrugTab = () => {
  const { query } = useRouter();
  const { navigateToPdp } = useProductNavigation();

  const { data, isLoading } = useGetPaginateCarouselProduct({
    carouselId: query?.id,
    search: query?.search,
    pageSize: query?.pageSize || 20,
    pageNumber: query?.pageNumber || 1,
  });

  const pageSize = Number(query.pageSize as string);

  const isShownPagination = data?.totalCount / pageSize > 1;
  return (
    <>
      <div className="flex flex-col">
        <div className="grid grid-cols-2 gap-4 px-4 pb-4 pt-2">
          {isLoading && (
            <>
              {[...Array(8).keys()].map((item) => (
                <NonOtcPlpVeticalCardShimmer key={item} />
              ))}
            </>
          )}

          {data?.queryResult?.length > 0 &&
            data?.queryResult?.map((item) => (
              <PlpVerticalCard
                type="nonOtc"
                onClick={() =>
                  navigateToPdp({ item, ProductTypeId: item.productType })
                }
                product={{ ...item, brandName: null }}
                key={item?.irc}
                hasAddToCart
              />
            ))}
        </div>

        {isShownPagination && (
          <Pagination lastPage={Math.floor(data?.totalCount / pageSize) + 1} />
        )}
      </div>
    </>
  );
};

export default DrugTab;
